import React from "react";

import { getIntegrationForKey, type renderPillArgument } from "~/integrations/actionItemIntegration";
import { WidgetInner } from "~/integrations/actionItemIntegration/Widget";

export const hubspotTaskSpecificDataNodeTypename = "HubspotTaskActionItemIntegrationSpecificDataNode";

export function HubspotTaskActionItemIntegrationLinkWidget({ actionItemLink, customClassName }: renderPillArgument) {
	if (actionItemLink.integrationData.__typename !== hubspotTaskSpecificDataNodeTypename) {
		throw new Error("Incorrect integration to render pill");
	}
	const { hubspotUrl } = actionItemLink.integrationData;
	const updating = actionItemLink.syncStatus !== "DONE_SYNCING_EXTERNALLY";
	const logo = getIntegrationForKey("HUBSPOT_TASK").logo;

	return (
		<WidgetInner logo={logo} updating={updating} url={hubspotUrl} customClassName={customClassName}>
			HubSpot
		</WidgetInner>
	);
}
